module.exports = new __parcel__URL__("delivery-dark.cece1e61.svg").toString();